import { Route, Routes, useLocation } from 'react-router-dom';
import './App.css';
import { lazy, Suspense, useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import Cookies from 'js-cookie';
import { Box, CircularProgress, CssBaseline } from '@mui/material';
import NavBar from './components/Navbar';
import FixedBtn from './components/global/FixedBtn';
import Footer from './components/Footer/Footer';
import NotFound from './pages/NotFound';
// import TopBar from './components/Navbar/TopBar';
import { useWebsiteSettings } from './hooks/useWebsiteSettings';

const Home = lazy(() => import("./pages/Home"));
const About = lazy(() => import("./pages/About"));
const ContactUs = lazy(() => import("./pages/ContactUs"));
const Services = lazy(() => import("./pages/Services"));
const Projects = lazy(() => import("./pages/Projects"));
const ProjectDetail = lazy(() => import("./pages/ProjectDetail"));
const OurBlogs = lazy(() => import("./pages/OurBlogs"));
const Blog = lazy(() => import("./pages/Blog"));
const Ugc = lazy(() => import("./pages/Ugc"));

const languages = [
    { code: 'ar', name: 'Ar', country_coode: 'sa', dir: 'rtl' },
    { code: 'en', name: 'En', country_coode: 'gb', dir: 'ltr' },
];

function App() {
    const { settings } = useWebsiteSettings();
    const currentLanguageCode = Cookies.get('i18next') || 'ar';
    const currentLanguage = useMemo(() => languages.find(l => l.code === currentLanguageCode), [currentLanguageCode]);
    const { t } = useTranslation();

    useEffect(() => {
        document.dir = currentLanguage.dir || 'rtl';
        document.getElementsByTagName('html')[0].setAttribute('lang', currentLanguage.code || 'ar');
    }, [currentLanguage, t]);

    const ScrollToTop = () => {
        const { pathname } = useLocation();
        useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
        return null;
    };

    return (
        <div className="App">
            <Box sx={{ bgcolor: '#020814', color: '#FFFFFF' }}>

                <CssBaseline />
                <FixedBtn data={settings} />
                {/* <TopBar data={settings} /> */}
                <NavBar data={settings} />
                <ScrollToTop />
                <Suspense fallback={
                    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
                        <CircularProgress />
                    </Box>
                }>
                    <Routes>
                        <Route path="/" element={<Home />} />
                        <Route path="/about" element={<About />} />
                        <Route path="/services" element={<Services />} />
                        <Route path="/projects" element={<Projects />} />
                        <Route path="/projects/:slug" element={<ProjectDetail />} />
                        <Route path="/blogs" element={<OurBlogs />} />
                        <Route path="/blogs/:slug" element={<Blog />} />
                        <Route path="/ugc" element={<Ugc />} />
                        <Route path="/contact" element={<ContactUs />} />
                        <Route path="*" element={<NotFound />} />
                    </Routes>
                </Suspense>
                <Footer data={settings} />
            </Box>
        </div>
    );
}

export default App;
